import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useMemo, useCallback } from "react";
import { Button, Form, Modal, OverlayTrigger } from "react-bootstrap";
import moment from "moment";
import { useFormik } from "formik";
import { DateRangePicker } from "rsuite";
import { BiSearch } from "react-icons/bi";
import Sidebar from "../../includes/Sidebar";
import { FileReportService } from "../../../services/FileReportService";
// import FileReportDetails from "./FileReportDetails";
import { BsCloudDownloadFill } from "react-icons/bs";
import { downloadXl, predefinedBottomRanges } from "../../../functions";
import { IconButton, TextField, Tooltip } from "@mui/material";
import { seErrorMessage } from "../../../slice/error/errorSlice";
import { useDispatch, useSelector } from "react-redux";
import Select, { components } from 'react-select';
import { useRef } from "react";
import { InvoiceReportService } from "../../../services/InvoiceReportService";
import { TbGridDots, TbReload } from "react-icons/tb";
import { HiChevronDown } from "react-icons/hi";
import DownloadDropDown from "../../components/DownloadDropDown";
import { selectIsSuperUser, selectPermissions } from "../../../slice/user/userSlice";
import FilterUnMatchModal from "../../../utils/modal";
import { getUnmatchedKeys } from "../../../utils/objectUtils";
import FileReportDetails from "../FileReport/FileReportDetails";
import { AiOutlineClose } from "react-icons/ai";
import { MdOutlineFileCopy } from "react-icons/md";


const datatableCustomStyles = {
  rows: {
    style: {
      minHeight: '40px', 
      fontSize: '0.7em',
      fontColor: '#212529 !important',
      width: '100%'
    },
  },
  headCells: {
    style: {
      paddingLeft: '5px', 
      paddingRight: '5px',
      textTransform: "uppercase",
      fontSize: '0.7em',
      fontWeight: '800',
      fontColor: '#6c757d !important',
      opacity: 1,
      minHeight: "10px",
    },
  },
  cells: {
    style: {
      paddingLeft: '8px', 
      paddingRight: '8px',
    },
  },
  pagination: {
    style: {
      color: '#000',
      fontSize: '13px',
      minHeight: '56px',
      backgroundColor: '#fff',
      borderTopStyle: 'solid',
      borderTopWidth: '1px',
      borderTopColor: '#f2f2f2',
    },
    pageButtonsStyle: {
      borderRadius: '50%',
      height: '40px',
      width: '40px',
      padding: '8px',
      margin: '0px',
      cursor: 'pointer',
      transition: '0.4s',
      color: '#000',
      fill: '#000',
      backgroundColor: 'transparent',
      '&:disabled': {
        cursor: 'unset',
        color: '#e2e2e2',
        fill: '#e2e2e2',
      },
      '&:hover:not(:disabled)': {
        backgroundColor: '#f2f2f2',
      },
      '&:focus': {
        outline: 'none',
        backgroundColor: '#f5f5f5',
      },
    },
  },
};

function ExceptionReport() {
  const dispatch = useDispatch()
  const facilityRef = useRef(null)
  const clientRef = useRef(null)

  const [reRenderDataTable, setRerenderDataTable] = useState(false)
  const [pageno, setPageNo] = useState(1);
  const [loading, setLoading] = useState(false);
  const [isTimeCount, setisTimeCount] = useState(false);
  const [totalRows, setTotalRows] = useState(100);
  const [filterText, setFilterText] = useState('');
  const [colorRow, setColorRow] = React.useState({});
  const [data, setData] = useState({})
  const [limit, setLimit] = useState(100)
  const [searchedData, setSearchedData] = useState({
    search: "",
    created_by:"",
     module:"",
     functions:"",
     created_date_range:"",

  })



  const [clients, setClients] = useState([]);


  const [selectValue, setSelectValue] = useState([])




  const [selectedFacility, setSelectedFacility] = useState([])

  const [selectedFacilityIds, setSelectedFacilityIds] = useState("")
  const [isInitSearch, setIsInitSearch] = useState(true)

  const [unmatchFilterModalShow, setUnmatchFilterModalShow] = useState(false);
  const [exceptionModal, setExceptionModal] = useState({ show: false, message: "", title: "" });

  const handleModalClose = () => setUnmatchFilterModalShow(false);
  const handleModalShow = () => setUnmatchFilterModalShow(true);


  const fileReportService = new FileReportService();


  const { getExceptionReportSummery } = fileReportService




  const handlePerRowsChange = async (newPerPage, page) => {

    setLimit(newPerPage);
    setPageNo(1)
    fetchData(1, newPerPage, searchedData?.module, searchedData?.functions, searchedData?.created_date_range,searchedData?.created_by);
    handleResetDataTable()

  };

  const handlePageChange = page => {
    setPageNo(page)
    fetchData(page, limit, searchedData?.module, searchedData?.functions, searchedData?.created_date_range,searchedData?.created_by);
  };


  const fetchData = (page, limit, module, functions, created_date_range,created_by) => {
    setLoading(true)
    getExceptionReportSummery(page, limit, created_date_range, functions, module,created_by).then((response) => {
      setData(response?.data);
      setLimit(limit);
      setPageNo(page)
      setTotalRows(response?.data?.count);
      setLoading(false);
      if (response?.errors?.date_range) {
        dispatch(seErrorMessage({ message: response?.errors?.date_range[0], is_show: true }))
      }
    });

  }

 const CopyButton = (props)=> {
    const {copyText = ''} = props
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(copyText);
      setCopied(true);

      setTimeout(() => {
        setCopied(false);
      }, 2000);

    } catch (err) {
      console.error("Copy failed", err);
    }
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <button onClick={handleCopy}
              style={{
                  background: "transparent",
                  border: "none",
                  padding: 0,
                  cursor: "pointer"
              }} >
        <MdOutlineFileCopy  size={18}/>
      </button>

      {copied && (
        <span style={{fontSize:'12px'}} >
          Copied!
        </span>
      )}
    </div>
  );
}


  const handleRowClickCheck = (row) => {
    data?.results.map((item, index) => {
      if (row?.id == item.id) {
        setColorRow(row)
      }
    })
  }


  const [expandedRows, setExpandedRows] = useState([]);


  const handleRowExpand = useCallback((row) => {
    const unmatchedkey = getUnmatchedKeys(searchedData, searchFormik.values)
    if (unmatchedkey.length > 0) {
      handleModalShow()
    }
    else {
      setColorRow(row);
      const isRowExpanded = expandedRows.includes(row);

      setExpandedRows(isRowExpanded ? expandedRows.filter((r) => r !== row) : [row]);
    }
  });

  const searchFormik = useFormik({
    initialValues: {
      search: "",
      module: "",
      functions: "",
      created_date_range: "",
      created_by: "",
      date_range: null,
    },


    onSubmit: (values) => {
      setIsInitSearch(false)
      searchData(values)

      setSearchedData({
        search: values?.search ? values?.search : "",
        created_date_range: values?.created_date_range ? values?.created_date_range : "",
        module: values?.module ? values?.module : "",
        functions: values?.functions ? values?.functions : "",
        created_by: values?.created_by ? values?.created_by : "",
      })
      handleResetDataTable()
    }
  })
  const handleModalOk = () => {
    // Call the API here
    handleModalClose()
    searchFormik.handleSubmit()

  };

  const columns = useMemo(
    () => [
      {
        id: 'S.NO',
        name: 'S.NO',
        selector: (row, index) => pageno == 1 ? index + 1 : (pageno - 1) * limit + index + 1,
        wrap: true,
        width: "60px",
        // :grow 4,

      },

    
      {
        id: "created_date",
        name: "created date",
        selector: row => row?.created_date,
        width: "130px",
        wrap: true,
        cell: (row) => {
          return (
            <div onClick={() => handleRowClick(row)}>
              {row?.created_date}
            </div>
          )
        }
      },

      {
        id: "created_by",
        name: "created by",
        selector: row => row?.created_by,
        width: "150px",
        wrap: true,
        cell: (row) => {
          return (
            <div onClick={() => handleRowClick(row)}>
              {row?.created_by}
            </div>
          )
        }
      },

      {
        id: "module",
        name: "module",
        selector: row => row?.module,
        width: "150px",
        wrap: true,
        cell: (row) => {
          return (
            <div onClick={() => handleRowClick(row)}>
              {row?.module}
            </div>
          )
        }
      },

      {
        id: "function",
        name: "function",
        selector: row => row?.function,
        
        wrap: true,
        cell: (row) => {
          return (
            <div onClick={() => handleRowClick(row)}>
              {row?.function}
            </div>
          )
        }
      },

      {
        id: "exception_message",
        name: "exception message",
        selector: row => row?.exception_message,
        wrap: true,
       grow:3,
        minWidth: "350px",
     cell: (row) => {
                    const message = row?.exception_message;
                    if (!message) return "-";
                    
                    // const isLong = message.length > 100 || message.includes('\n') || message.includes('|');

                    // if (isLong) {
                        return (
                            <div 
                                onClick={() => {
                                    handleRowClickCheck(row);
                                    setExceptionModal({ 
                                        show: true, 
                                        message: message, 
                                        title: row.module ? `Error Message: ${row.module}` : "Error Message" 
                                    });
                                }} 
                                className="cursor-pointer d-flex flex-column py-2"
                                style={{ minWidth: '200px'}}
                            >
                                <div className="text-truncate text-dark" style={{ maxWidth: '650px' }}>
                                    {message}
                                </div>
                                {/* <div className=" small fw-bold mt-1" style={{ fontSize: '12px' }}>
                                    view full Error message
                                </div> */}
                            </div>
                        );
                    // }

                    // return (
                    //     <span onClick={() => handleRowCheckClick(row)} className="cursor-pointer d-block py-2">
                    //         {message}
                    //     </span>
                    // );
                },
      }


    ],

    [handleRowExpand, limit, pageno, isTimeCount],
  );

  var i = 0;
  const conditionalRowStyles = [

    {
      when: row => colorRow.id == row.id ? true : false,
      style: (row, index) => ({
        backgroundColor: colorRow?.id == row.id ? '#dbf4f5' : '#f2f2f2',
        color: 'black',
        // fontWeight: '550'
      }),
    },


  ];
  const handleRowClick = (row) => {

    const unmatchedkey = getUnmatchedKeys(searchedData, searchFormik.values)
    if (unmatchedkey.length > 0) {
      handleModalShow()
    }
    else { // setColorRow(row);
      // setExpandedRows([])
      setColorRow(row);
      const isRowExpanded = expandedRows.includes(row);

      setExpandedRows(isRowExpanded ? expandedRows.filter((r) => r !== row) : [row]);
    }
  };



  const [datetime, setDateTime] = useState([]);

  const handleOnDateTimeChange = ({ name, value }) => {
    setExpandedRows([])
    let created_date_range = ""
    if (value !== null && value.length === 2) {
      const startDate = value[0];
      const endDate = value[1];
      // Check if the start date is after the end date, and swap the dates if needed
      let isGreater = false
      if (startDate > endDate) {
        isGreater = true
      }
      const datefrom = moment(isGreater ? endDate : startDate).format('MM/DD/YYYY HH:mm:ss')
      const dateto = moment(isGreater ? startDate : endDate).format('MM/DD/YYYY HH:mm:ss')

      created_date_range = datefrom + " - " + dateto
      searchFormik.setValues({ ...searchFormik.values, created_date_range, date_range: value })
    } else {
      setSearchedData({
        ...searchedData,
        created_date_range: '',
      })
      searchFormik.setValues({ ...searchFormik.values, created_date_range: "", date_range: null })
      fetchData(1, limit, searchedData?.module, searchedData?.functions, "", searchedData?.created_by);
    }

    setDateTime(created_date_range)   
  }






  const searchData = ({ module, functions, created_date_range,created_by }) => {
    fetchData(1, limit, module, functions, created_date_range,created_by)
  }


  const permissions = useSelector(selectPermissions);
  const isSuperUser = useSelector(selectIsSuperUser);
  const isHavePermission = (name) => {
    return permissions?.includes(name) || isSuperUser
  }

  const showTooltip = (text, props) => (
    <Tooltip id="button-tooltip" {...props}>
      {text}
    </Tooltip>
  );


  const handleResetDataTable = () => {
    setRerenderDataTable(true)
    // setTimeout(() => {
    //   setRerenderDataTable(false)
    // }, 200);
  }
  const [loader, setLoader] = useState(false);





  const DropdownIndicator = ({ state, ...props }) => {
    console.log(state?.length, state)
    return (
      <components.DropdownIndicator {...props}>

        {state?.length > 1 ? (
          <TbGridDots style={{ fontSize: "1.5em" }} />
        ) : (
          <HiChevronDown style={{ fontSize: "1.5em" }} />
        )}



      </components.DropdownIndicator>
    );
  };



  return (
    <React.Fragment>
      {/* <Header /> */}
      <Sidebar />
      <main id="main" className="main">

        <div className="pagetitle tab-fixed-header">
          <h1 id='page-title'>Exception Report</h1>
        </div>

        <section className="section mt-5 ">
          <div className="row align-items-top py-2 gap-2 gap-md-5">
            <div className="col-lg-12">
              <div className="card mb-5 mb-xl-8" style={{ height: "92vh" }}>

                <Form onSubmit={searchFormik.handleSubmit} >
                  <div className=" ">
                    <div className="px-1 py-1 d-flex flex-row justify-content-start gap-2 align-items-center flex-wrap">

               <Tooltip disableInteractive title={"Created By"} placement="top" arrow>
                          <TextField
                            InputProps={{
                              endAdornment: searchFormik.values.created_by && (
                                <IconButton onClick={() => searchFormik.setFieldValue("created_by", "")}>
                                  <AiOutlineClose size={"0.6em"} />
                                </IconButton>
                              ),
                            }}
                            id="standard-basic-created_by"
                            name="created_by"
                            value={searchFormik?.values?.created_by}
                            onChange={searchFormik.handleChange}
                            label="Created By"
                            className='me-2'
                            variant="standard"
                          />
                        </Tooltip>



                      <div className="d-flex align-items-center gap-2 flex-wrap">
                        <Tooltip disableInteractive title={"Module"} placement="top" arrow>
                          <TextField
                            InputProps={{
                              endAdornment: searchFormik.values.module && (
                                <IconButton onClick={() => searchFormik.setFieldValue("module", "")}>
                                  <AiOutlineClose size={"0.6em"} />
                                </IconButton>
                              ),
                            }}
                            id="standard-basic-module"
                            name="module"
                            value={searchFormik?.values?.module}
                            onChange={searchFormik.handleChange}
                            label="Module"
                            className='me-2'
                            variant="standard"
                          />
                        </Tooltip>

                        <Tooltip disableInteractive title={"Function"} placement="top" arrow>
                          <TextField
                            InputProps={{
                              endAdornment: searchFormik.values.functions && (
                                <IconButton onClick={() => searchFormik.setFieldValue("functions", "")}>
                                  <AiOutlineClose size={"0.6em"} />
                                </IconButton>
                              ),
                            }}
                            id="standard-basic-function"
                            name="functions"
                            value={searchFormik?.values?.functions}
                            onChange={searchFormik.handleChange}
                            label="Functions"
                            className='me-2'
                            variant="standard"
                          />
                        </Tooltip>

                        <Tooltip disableInteractive title={"created date"} placement="top" arrow>
                          <div className={`${searchFormik.errors.created_date_range ? "date-range-pickr-error " : ""} correspondenceDatePicker`}>
                            <DateRangePicker
                              ranges={predefinedBottomRanges}
                              cleanable
                              placement="auto"
                              appearance="default"
                              format={"MM/dd/yyyy HH:mm:"}
                              className="form-date-control form-control-solid b-r-1 text-dark"
                              defaultCalendarValue={[new Date().setHours(0, 0, 0, 0), new Date().setHours(23, 59, 59, 59)]}
                              placeholder={"MM/DD/YYYY - MM/DD/YYYY"}
                              name="created_date_range"
                              onChange={(e) => { handleOnDateTimeChange({ name: 'created_date_range', value: e }) }}
                              value={searchFormik?.values?.date_range || null}
                            />
                          </div>
                        </Tooltip>
                        <Tooltip disableInteractive title={"Search"} placement="top" arrow>
                          <Button className="btn btn-light btn-active-primary" type="submit">
                            <span className="svg-icon svg-icon-3">
                              <BiSearch />
                            </span>
                          </Button>
                        </Tooltip>

                        <Tooltip disableInteractive title={"Reset"} placement="top" arrow>
                          <Button 
                            className="btn btn-light btn-active-primary" 
                            type="button"
                            onClick={() => {
                              searchFormik.resetForm();
                              setDateTime("");
                              setSelectValue([]);
                              setSelectedFacility([]);
                              fetchData(1, limit, "", "", "", "", [], []);
                            }}
                          >
                            <span className="svg-icon svg-icon-3">
                              <TbReload />
                            </span>
                          </Button>
                        </Tooltip>
                      </div>
                    </div>
                  </div>

                </Form>


                <div className="card-body p-common">
                  <div className="table-responsive">
                    <div className="dashboardtable">
                      {/* {!reRenderDataTable && */}
                      <DataTable
                        className="custom-datatable"
                        paginationDefaultPage={pageno}
                        noDataComponent={isInitSearch ? <p className="p-4">Apply filters to refine and display the data</p> : <p className="p-4">There are no records to display</p>}

                        fixedHeader={true}
                        progressPending={loading}
                        data={data?.results}
                        columns={columns}
                        pointerOnHover={true}
                        pagination
                        paginationServer
                        onRowClicked={handleRowClick}
                        // highlightOnHover
                        paginationTotalRows={totalRows}
                        paginationPerPage={limit}
                        paginationRowsPerPageOptions={[25, 50, 100]}
                        onChangeRowsPerPage={handlePerRowsChange}
                        onChangePage={handlePageChange}
                        conditionalRowStyles={conditionalRowStyles}
                        theme="solarized"
                        customStyles={datatableCustomStyles}
                        striped={true}
                        expandableRows
                        // expandOnRowClicked={false}
                        onRowExpandToggled={handleRowExpand}
                        expandableRowsHideExpander
                        // expandableRowExpanded={(row) => expandedRows.includes(row)}

                      />
                      {/* } */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

    

        <Modal show={exceptionModal.show} onHide={() => setExceptionModal({ ...exceptionModal, show: false })} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title className="me-3">{exceptionModal.title }</Modal.Title>
                  <CopyButton copyText={exceptionModal.message} />
          </Modal.Header>
          
          <Modal.Body>
            <div style={{
              backgroundColor: '#f8f9fa',
              padding: '15px',
              borderRadius: '5px',
              maxHeight: '400px',
              overflowY: 'auto'
            }}>
              <pre style={{
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                fontSize: '13px',
                color: '#333'
              }}>
                {exceptionModal.message}
              </pre>
            </div>
          </Modal.Body>
          <Modal.Footer>
  
          </Modal.Footer>
        </Modal>

      </main>
    </React.Fragment >
  )
}
export default ExceptionReport




